import { BaseModel } from "../products/base";
import { FabricSwatch } from "../products/fabric";
import { Finish, FinishHandle } from "../products/finish";
import { UmbrellaModel } from "../products/umbrella";
import * as option from "./configurator_options";

export type ConfigFile = {
  _id?: string;
  public?: boolean;
  layout: {
    collection?: {
      handle: string;
    };
    productline?: {
      handle: string;
    };
    preset: option.Preset;
  };
  shape: {
    model: string;
  };
  base: {
    base: string | null;
    baseFinish: FinishHandle | null;
    baseStem: option.Stem | null;
    baseOptions?: {
      wheels?: boolean;
      topCover?: {
        model: string;
        finish: Finish;
      };
    };
  };
  frame: {
    finish: FinishHandle;
    finial: option.Finial;
    finialFinish: option.FinialFinishType | null;
    bottomPole: option.BottomPole | null;
    spigot?: option.Spigot | null;
  };
  canopy: {
    mainCanopy: option.Panel;
    mainFabric: string[]; // Array will contain 2 fabric mfr_codes if alternating panels, else 1
    mainTrimFabric: string | null;
    mainTrimFabricInner: string | null;
    ventTopFabric: string[];
    ventMiddle: option.Panel | null;
    ventMiddleFabric: string[]; // Array will contain 2 fabric mfr_codes if alternating panels, else 1
    ventTrimFabric: string | null;
    valance: option.Valance;
    valanceFabric: string[]; // if valance is present, array will contain 2 fabric mfr_codes if main canopy alternating panels, else 1
    fringe: option.Fringe;
    fringeFabric: string[]; // Up to 3 fabric mfr_codes
    bindingFabric: string | null;
    rib: option.Rib | null;
    ribFabric: string | null; // null if rib === 'grommet'
    undersideFabric: string | null;
  };
  name?: string;
  image?: string;
  share_id?: string;
  created_at?: Date | string;
  updated_at?: Date | string;
};

export interface QuickshipConfigFile extends ConfigFile {
  type: ConfigType.QS;
  umbrella?: UmbrellaModel[];
  fabric?: FabricSwatch[];
  baseObject?: BaseModel[];
}

export enum ConfigType {
  QS = "quickship"
}
